import angular from 'angular';
import { YoutubeIframe } from '../youtube-iframe';
import { RenderWithWrapper } from '../../../global/global.react';
class YoutubeIframeBridgeController {
    constructor($element, $scope) {
        this.$element = $element;
        this.$scope = $scope;
        this.render = () => {
            RenderWithWrapper(YoutubeIframe, { videoUrl: this.videoUrl }, this.$element[0], this.$scope);
        };
    }
    $onInit() {
        this.render();
    }
}
const youtubeIframeBridge = {
    template: '<div></div>',
    bindings: { videoUrl: '<' },
    controller: YoutubeIframeBridgeController,
};
export default angular
    .module('doxy.common.components.youtubeIframeBridge', [])
    // youtube-iframe-bridge
    .component('youtubeIframeBridge', youtubeIframeBridge).name;
